export const Categories = ({
  isLoading,
  categories,
  selectedCategories,
  handleFilterSelect,
  selectedFilters,
  optAllStates,
  handleCategoryClick
}) => {
  const checkCategorySelected = (id) => {
    return selectedCategories.some((cat) => cat.category_id === id);
  };

  return (
    <div className="category-grid">
      {!isLoading.gettingSubscriptions &&
        categories.map((category) => {
          const isSelected = checkCategorySelected(category.id);
          const hasFilters = selectedFilters[category.id]?.length > 0;
          const isOptAll = optAllStates[category.id];

          return (
            <div
              key={category.id}
              className={`category-item ${isSelected ? "selected" : ""}`}
              onClick={() => handleCategoryClick(category.id)}>
              {isSelected && (
                <span
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    width: "100%"
                  }}>
                  <span
                    className="category-edit-wrapper"
                    onClick={(e) => {
                      e.stopPropagation();
                      handleFilterSelect(category.id);
                    }}
                  >
                    <i className="fa fa-pencil category-edit-icon"></i>
                  </span>

                  {hasFilters ? (
                    <span
                      className="circular-chip"
                      style={{ background: "white", color: "#5B68C3" }}>
                      <span className="filter-count">
                        {selectedFilters[category.id].length}
                      </span>
                    </span>
                  ) : isOptAll ? (
                    <span
                      className="circular-chip"
                      style={{ background: "white", color: "#5B68C3" }}>
                      <i className="fa fa-check" style={{ fontSize: "12px" }}></i>
                    </span>
                  ) : null}
                </span>
              )}
              <i className={`fa ${category.icon} category-icon`}></i>
              <span style={{ fontSize: "14px" }}>{category.text}</span>
            </div>
          );
        })}
    </div>
  );
};